<template>
  <div class="container">
    <div class="projector">{{$t('T_RESULT_PROJECTOR_SETTING')}}</div>
    <hr>
    <div class="read-model-list">
      <div class="label ft">
        <label>1、{{$t('T_READ_CURRENT_MODEL_LIST')}}</label>
      </div>
      <div class="list-but">
        <el-upload
          accept="json"
          action
          :on-change="fileChange"
          :auto-upload="false"
          :show-file-list="false"
        >
          <el-button type="button">{{$t('T_PRESS_HERE')}}</el-button>
        </el-upload>
      </div>
    </div>
    <hr>
    <div class="updata-model-list">
      <div class="label ft">
        <label>2、{{$t('T_NEWEST_MODEL_LIST_UPDATE')}}</label>
      </div>
      <div class="list-but">
        <el-upload
          accept="json"
          action
          :on-change="newDataChange"
          :auto-upload="false"
          :show-file-list="false"
          :disabled="showFlag?false:true"
        >
          <el-button type="button" :disabled="showFlag?false:true">{{$t('T_PRESS_HERE')}}</el-button>
        </el-upload>
      </div>
    </div>
    <hr>
    <div class="make-esc">
      <div class="label">
        <label>3、{{$t('T_ESCS_SITUATION_MODIFY')}}</label>
      </div>
      <div class="modelist-table" v-if="showFlag">
        <el-table
          v-if="this.filterData.length > 0"
          :data="filterData"
          style="width: 100%"
          max-height="680"
          :row-class-name="tableRowClassName"
          :header-cell-class-name="headerCellStyle"
          :default-sort = "{prop: 'modelSeries'}"
        >

          <el-table-column prop label fixed="left" width="240">
            <template slot="header" slot-scope="scope">
              <el-select v-model="projectValue" filterable @change="changeFilter">
                <el-option
                  v-for="(item,index) in projectName"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </template>
            <el-table-column prop label>
              <el-table-column prop="modelSeries" :label="$t('T_MAINTENANCE_MODEL_SERIES')" width="120" sortable :sort-method="(a, b)=>sortHandle(a, b, 'modelSeries')"></el-table-column>
              <el-table-column prop="name" :label="$t('T_MAINTENANCE_MODEL_NAME')" width="120"></el-table-column>
            </el-table-column>
          </el-table-column>
          <el-table-column prop label>
            <el-table-column prop label>
              <el-table-column prop="Search" :label="$t('T_SEARCH')" width="95">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.Search" :checked="scope.row.discontinued ? false : (scope.row.Search || scope.row.Search === undefined)" @change = handlePjSearchChange(scope)></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="recommend" :label="$t('T_RECOMMEND')" width="100">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.recommend" :checked="scope.row.discontinued ? false :(scope.row.recommend || scope.row.recommend === undefined)" @change = handlePjRecommendChange(scope)></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="discontinued" :label="$t('T_DISCONTINUED')" width="100">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.discontinued" :checked="scope.row.Search ||scope.row.recommend ? false : scope.row.discontinued" @change = handlePjDiscontinuedChange(scope)></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="Businessmodel" :label="$t('T_BUSINESS_MODEL')">
            <el-table-column :label="$t('T_CATEGORY1')">
              <el-table-column width="100">
                <template slot="header">
                  <el-input v-model="c0" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c0" :checked="scope.row.c0 || (scope.row.c0 === undefined && (scope.row.category === 0 || scope.row.category === 1 || scope.row.category === 2))">
                  </el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Category2" :label="$t('T_CATEGORY2')">
              <el-table-column width="100">
                <template slot="header">
                  <el-input v-model="c1" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c1" :checked="scope.row.c1 || (scope.row.c1 === undefined && (scope.row.category === 3 || scope.row.category === 4))"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Category3" :label="$t('T_CATEGORY3')">
              <el-table-column width="100">
                <template slot="header">
                  <el-input v-model="c2" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c2" :checked="scope.row.c2 || (scope.row.c2 === undefined && (scope.row.category === 6 || scope.row.category === 7))"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Category4" :label="$t('T_CATEGORY4')">
              <el-table-column width="120">
                <template slot="header">
                  <el-input v-model="c3" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c3" :checked="scope.row.c3 || (scope.row.c3 === undefined && scope.row.category === 8)"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Category5" :label="$t('T_CATEGORY5')">
              <el-table-column width="130">
                <template slot="header">
                  <el-input v-model="c4" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c4" :checked="scope.row.c4 || (scope.row.c4 === undefined && scope.row.category === 9)"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Category6" :label="$t('T_CATEGORY6')">
              <el-table-column width="130">
                <template slot="header" slot-scope="scope">
                  <el-input v-model="c5" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c5"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="Homemodel" :label="$t('T_HOME_MODEL')">
            <el-table-column prop="Category7" :label="$t('T_CATEGORY1')">
              <el-table-column width="130">
                <template slot="header">
                  <el-input v-model="c6" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c6" :checked="scope.row.c6 || (scope.row.c6 === undefined && scope.row.category === 5)"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Category8" :label="$t('T_CATEGORY2')">
              <el-table-column width="130">
                <template slot="header">
                  <el-input v-model="c7" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c7"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="Category9" :label="$t('T_CATEGORY3')">
              <el-table-column width="130">
                <template slot="header" slot-scope="scope">
                  <el-input v-model="c8" size="mini" placeholder="Please enter"/>
                </template>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.c8"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table-column>
          <div slot="empty">
            <span>{{ $t('T_NO_DATA') }}</span>
          </div>
        </el-table>
      </div>
    </div>
    <hr>
    <div class="read-model-list">
      <div class="label ft">
        <label>4、{{$t('T_SETTING_OUTPUT')}}</label>
      </div>
      <div class="list-but">
        <el-button type="button" @click="saveFile()" :disabled="showFlag?false:true">{{$t('T_BUTTON_SAVE')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
var compare = (a, b, val) => {
  if (val) {
    return a[val].toLowerCase().localeCompare(b[val].toLowerCase())
  }
  return a.toLowerCase().localeCompare(b.toLowerCase())
}
export default {
  components: {},
  props: {},
  data () {
    return {
      search: '',
      dataKeyCol: '',
      inds: [],
      showFlag: false,
      modelData: null,
      projectValue: 'All models',
      projectName: [],
      filterData: []
    }
  },
  watch: {},
  computed: {
    c0: {
      get () {
        return this.pcateGoryGet(0)
      },
      set (value) {
        this.pcateGorySet(0, value)
      }
    },
    c1: {
      get () {
        return this.pcateGoryGet(1)
      },
      set (value) {
        this.pcateGorySet(1, value)
      }
    },
    c2: {
      get () {
        return this.pcateGoryGet(2)
      },
      set (value) {
        this.pcateGorySet(2, value)
      }
    },
    c3: {
      get () {
        return this.pcateGoryGet(3)
      },
      set (value) {
        this.pcateGorySet(3, value)
      }
    },
    c4: {
      get () {
        return this.pcateGoryGet(4)
      },
      set (value) {
        this.pcateGorySet(4, value)
      }
    },
    c5: {
      get () {
        return this.pcateGoryGet(5)
      },
      set (value) {
        this.pcateGorySet(5, value)
      }
    },
    c6: {
      get () {
        return this.pcateGoryHtmGet(0)
      },
      set (value) {
        this.pcateGoryHtmSet(0, value)
      }
    },
    c7: {
      get () {
        return this.pcateGoryHtmGet(1)
      },
      set (value) {
        this.pcateGoryHtmSet(1, value)
      }
    },
    c8: {
      get () {
        return this.pcateGoryHtmGet(2)
      },
      set (value) {
        this.pcateGoryHtmSet(2, value)
      }
    }
  },
  methods: {
    sortHandle (a, b, val) {
      return compare(a, b, val)
    },
    clickLoad () {
      this.$refs.refFile.dispatchEvent(new MouseEvent('click'))
    },
    fileLoad () {
      // 获取读取的文件File对象 下面两种方法实现效果一样
      // 方法一:原生html获取
      // const selectedFile = document.getElementById('files').files[0];
      // 方法二:Vue实现
      const selectedFile = this.$refs.refFile.files[0]

      var name = selectedFile.name // 选中文件的文件名
      var size = selectedFile.size // 选中文件的大小
      console.log('文件名:' + name + '大小:' + size)
    },
    pcateGoryGet (num) {
      if (!this.modelData) return
      if (
        this.modelData[0].categoliesBm &&
        this.modelData[0].categoliesBm.indexOf(',') !== -1
      ) {
        return this.modelData[0].categoliesBm.split(',')[num]
      } else {
        return this.$set(this.modelData[0], 'categoliesBm', '')
      }
    },
    pcateGorySet (num, value) {
      if (!this.modelData) return
      if (
        this.modelData[0].categoliesBm === '' ||
        this.modelData[0].categoliesBm === undefined
      ) {
        this.modelData[0].categoliesBm = ',,,,,'
      }
      var arrDesc = this.modelData[0].categoliesBm.split(',')
      arrDesc[num] = value
      this.modelData[0].categoliesBm = arrDesc.join()
    },
    pcateGoryHtmGet (num) {
      if (!this.modelData) return
      if (
        this.modelData[0].categoliesHtm &&
        this.modelData[0].categoliesHtm.indexOf(',') !== -1
      ) {
        return this.modelData[0].categoliesHtm.split(',')[num]
      } else {
        return this.$set(this.modelData[0], 'categoliesHtm', '')
      }
    },
    pcateGoryHtmSet (num, value) {
      if (!this.modelData) return
      if (
        this.modelData[0].categoliesHtm === '' ||
        this.modelData[0].categoliesHtm === undefined
      ) {
        this.modelData[0].categoliesHtm = ',,'
      }
      var arrDesc = this.modelData[0].categoliesHtm.split(',')
      arrDesc[num] = value
      this.modelData[0].categoliesHtm = arrDesc.join()
    },
    isNotEmpty (obj) {
      if (typeof obj === 'undefined' || obj === null || obj.trim === '') {
        return false
      } else if (obj.trim().length === 0) {
        return false
      } else {
        return true
      }
    },
    saveFile () {
      if (!this.modelData) {
        alert('modeldata为空')
        return
      }
      this.modelData[0].isMainPSConfig = 1
      this.renameCategory(0)
      this.renameCategory(1)
      this.renameCategory(2)
      this.renameCategory(3)
      this.renameCategory(4)
      this.renameCategory(5)

      this.renameHmCategory(0)
      this.renameHmCategory(1)
      this.renameHmCategory(2)

      let data = JSON.stringify(this.modelData)
      var blob = new Blob([data], { type: '' })
      saveAs(blob, 'projectorSpec.json')
    },
    renameCategory (num) {
      if (this.pcateGoryGet(num) === '') {
        this.pcateGorySet(num, 'Category' + (num + 1))
      }
    },
    renameHmCategory (num) {
      if (this.pcateGoryHtmGet(num) === '') {
        this.pcateGoryHtmSet(num, 'Category' + (num + 1))
      }
    },
    fileChange (file) {
      // if (file.name !== 'projectorSpec.json') {
      //   alert('upload error !')
      //   return
      // }
      this.modelData = null
      this.projectValue = 'All models'
      let reader = new FileReader()
      reader.readAsText(file.raw)
      reader.onload = e => {
        this.modelData = JSON.parse(e.target.result)
        if (!this.modelData || this.modelData.length === 0) return
        if (this.modelData[0].isMainPSConfig && this.modelData[0].isMainPSConfig === 1) {
          this.$set(this.modelData[0], 'categoliesBm', this.modelData[0].categoliesBm)
          this.$set(this.modelData[0], 'categoliesHtm', this.modelData[0].categoliesHtm)
        } else {
          this.$set(this.modelData[0], 'categoliesBm', 'Standard / Classroom / Mobile model,Short Throw / Ultra Short Throw model,Signage / Lighting model,High Brightness model(Lens fixed),High Brightness model(with optional lenses),')
          this.$set(this.modelData[0], 'categoliesHtm', '')
        }
        this.showFlag = true
        let name = this.modelData.map((item) => {
          return item.modelSeries
        })
        this.projectName = Array.from(new Set(name)).sort((a, b) => compare(a, b))
        this.projectName.unshift('All models')
        this.changeFilter()
        this.setTHeaderStyle()
      }
    },
    newDataChange (file) {
      let reader = new FileReader()
      reader.readAsText(file.raw)
      reader.onload = e => {
        let newData = JSON.parse(e.target.result)
        if (!newData || newData.length === 0) {
          return
        }
        this.projectValue = 'All models'
        if (this.modelData[0].isMainPSConfig && !newData[0].isMainPSConfig) {
          for (let i = 0; i < newData.length; i++) {
            let modelIndex = this.modelData.findIndex(item => item.name === newData[i].name)
            if (modelIndex !== -1) {
              newData[i]['Search'] = this.modelData[modelIndex]['Search']
              newData[i]['recommend'] = this.modelData[modelIndex]['recommend']
              newData[i]['discontinued'] = this.modelData[modelIndex]['discontinued']
              for (let j = 0; j < 9; j++) {
                if (this.modelData[modelIndex][`c${j}`]) {
                  newData[i][`c${j}`] = this.modelData[modelIndex][`c${j}`]
                }
              }
            } else {
              this.inds.push(newData[i].name)
            }
          }
        }
        this.modelData = JSON.parse(JSON.stringify(newData))
        if (this.modelData[0].isMainPSConfig && this.modelData[0].isMainPSConfig === 1) {
          this.$set(this.modelData[0], 'categoliesBm', this.modelData[0].categoliesBm)
          this.$set(this.modelData[0], 'categoliesHtm', this.modelData[0].categoliesHtm)
        } else {
          this.$set(this.modelData[0], 'categoliesBm', 'Standard / Classroom / Mobile model,Short Throw / Ultra Short Throw model,Signage / Lighting model,High Brightness model(Lens fixed),High Brightness model(with optional lenses),')
          this.$set(this.modelData[0], 'categoliesHtm', '')
        }
        let name = this.modelData.map((item) => {
          return item.modelSeries
        })
        this.projectName = Array.from(new Set(name)).sort((a, b) => compare(a, b))
        this.projectName.unshift('All models')
        this.changeFilter()
        this.setTHeaderStyle()
      }
    },
    setTHeaderStyle () {
      this.$nextTick(() => {
        let tHeader = document.getElementsByClassName('el-table__header')
        for (let item of tHeader) {
          let th = document.createElement('th')
          let tr = item.getElementsByTagName('tr')
          let th0 = tr[0].getElementsByTagName('th')
          let th1 = tr[1].getElementsByTagName('th')
          th0[0].rowSpan = 2
          th1[0].rowSpan = 1
          th1[0].colSpan = 1
          th1[1].rowSpan = 1
          th1[1].colSpan = 1
          th.style.borderRight = 'none'
          if (th1.length < 13) tr[1].insertBefore(th, th1[0])
        }
      })
    },
    headerCellStyle ({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0 && columnIndex === 1) {
        return 'bottom-none'
      } else if (rowIndex === 1 && columnIndex === 0) {
        return 'right-none'
      }
    },
    changeFilter () {
      this.filterData = []
      this.$nextTick(() => {
        if (this.projectValue === 'All models') {
          this.filterData = this.modelData
        } else {
          this.filterData = this.modelData.filter((item) => {
            return item.modelSeries === this.projectValue
          })
        }
      })
    },
    tableRowClassName ({ row }) {
      // console.log(rowIndex)
      if (this.inds.indexOf(row.name) !== -1) {
        return 'newFlag'
      } else {
        return ''
      }
    },
    handlePjDiscontinuedChange ({ row }) {
      row.Search = row.discontinued ? false : row.Search
      row.recommend = row.discontinued ? false : row.recommend
    },
    handlePjSearchChange ({ row }) {
      row.recommend = row.Search ? row.recommend : false
      row.discontinued = row.Search ? false : row.discontinued
    },
    handlePjRecommendChange ({ row }) {
      row.Search = row.recommend ? true : row.Search
      row.discontinued = row.recommend ? false : row.recommend
    }
  },
  created () {},
  mounted () {}
}
</script>
<style scoped>
.container {
  border-right: 2px solid #bdbdbd;
}

.projector {
  color: #000000;
  font-weight: bold;
  padding: 15px 20px;
}

.read-model-list,
.updata-model-list,
.make-esc {
  line-height: 45px;
}

.label {
  padding: 0px 25px;
}
table > tr {
  vertical-align: middle;
  overflow: scroll;
}
.option-text {
  margin-left: 30px;
  padding: 8px;
}
.tabs__item:nth-child(2) {
  padding-left: 0px;
}
.el-table__body-wrapper {
  overflow: auto;
  position: relative;
}
.el-table {
  height: auto;
}
.el-table >>> .caret-wrapper{
  display: none
}
/* .el-table >>> .bottom-none {
  border-bottom: unset !important;
}
.el-table >>> .right-none {
  border-right: unset !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/maintenanceTab/projectSearchMainTab.vue